import { render, staticRenderFns } from "./admin-place.vue?vue&type=template&id=f6fa4608&lang=pug&"
import script from "./admin-place.vue?vue&type=script&lang=js&"
export * from "./admin-place.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports